import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useRetailerType } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerType";
import { getIsBrandPreview, useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { UserStore, useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
/**
 * @deprecated Use `useIsLoggedInRetailer` instead
 */ export var isLoggedInRetailer = function() {
    return !!UserStore.get().userToken && !!RetailerStore.get().retailerToken && !RetailerStore.get().isGuestRetailer && !getIsBrandPreview();
};
export var useIsLoggedInRetailer = function() {
    var userToken = useUserStore([
        "userToken"
    ]).userToken;
    var retailerToken = useRetailer().retailerToken;
    var isGuestRetailer = useRetailerType().isGuestRetailer;
    var isBrandPreview = useIsBrandPreview();
    return !!userToken && !!retailerToken && !isBrandPreview && !isGuestRetailer;
};
export var useIsLoggedInRetailerOrBrandPreview = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isBrandPreview = useIsBrandPreview();
    return isLoggedInRetailer || isBrandPreview;
};
/**
 * @deprecated Use `useIsLoggedInRetailerOrBrandPreview` instead
 */ export var isLoggedInRetailerOrBrandPreview = function() {
    return isLoggedInRetailer() || getIsBrandPreview();
};
